import { useQuery } from '@tanstack/react-query'

import { axios } from '@apps-common/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@apps-common/lib/react-query'
import { ICompanyListModel } from '@apps-common/types/portal/company'

export const getRelatedCompanies = async (type: string): Promise<ICompanyListModel[]> =>
  axios.get(`/Unit/GetRelatedCompanies?type=${type}`).then((res) => res.data?.data)

type QueryFnType = typeof getRelatedCompanies

type Props = {
  config?: QueryConfig<QueryFnType>
  type: 'monitoring_centres' | 'bureaus' | 'technicians'
}

export const useGetRelatedCompanies = ({ config, type }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getRelatedCompanies', type],
    queryFn: () => getRelatedCompanies(type)
  })
